import {
    createContext
} from "react";
import type {
    TraceCodeBlockContextType
} from "./type";

export const TraceCodeBlockContext = createContext<TraceCodeBlockContextType>({
    isCopied: false
});
